import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Campaign from './pages/Campaign';
import Search from './pages/Search';
import LinkGenerator from './pages/LinkGenerator';
import Submissions from './pages/Submissions';
import AddEditSurvey from './pages/AddEditSurvey';
import GithubMarkdown from './pages/GithubMarkdown';
import Login from './pages/Login';
import Changepassword from './pages/ChangePassword';
import AdminHOC from './pages/AdminHOC';

import './custom.css'
import { Can_Display_Admin_UI } from './common/constants';

export default () => (
    <Layout>
        <Route exact path='/' component={Campaign} />
        <Route path='/campaign/:surveyCode?' component={Campaign} />
        { Can_Display_Admin_UI &&
        <>
            <Route path='/links/:surveyId' component={AdminHOC(LinkGenerator)} />
            <Route path='/submissions/:surveyId' component={AdminHOC(Submissions)} />
            <Route path='/edit/:isNew/:surveyId' component={AdminHOC(AddEditSurvey)} />
            <Route path='/search' component={AdminHOC(Search)} />
            <Route path='/markdown' component={AdminHOC(GithubMarkdown)} />
            <Route path='/login' component={Login} />
            <Route path='/changepassword' component={AdminHOC(Changepassword)} />
        </>}

    </Layout>
);
